exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#home-page{height:100%;background-image:url(" + require("../../../styles/images/background.jpg") + ");background-size:cover;background-position:center;background-repeat:no-repeat}#loader-container{display:flex;justify-content:center}@media(max-width: 850px){#home-page{background-image:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/pages/Home/styles.scss
// module id = 840
// module chunks = 0